import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneSU_NT_MRI_GeneralInformation = createAsyncThunk(
  "SU_NT_MRI_GeneralInformationServices/GetOneSU_NT_MRI_GeneralInformation",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_GeneralInformationServices/GetOneSU_NT_MRI_GeneralInformation",
        {
          applicationInformationId: applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateSU_NT_MRI_GeneralInformation = createAsyncThunk(
  "SU_NT_MRI_GeneralInformationServices/UpdateSU_NT_MRI_GeneralInformation",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_GeneralInformationServices/UpdateSU_NT_MRI_GeneralInformation",
        {
          generalInformationId: model.generalInformationId,
          typesOfSupportId: model.typesOfSupportId,
          ischecked: model.ischecked,

          applicationInformationId: model.applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const GeneralInformation = createSlice({
  name: "GeneralInformation",
  initialState: {
    GeneralInformationList: {},
    loadingGeneralInformationList: false,
    errorGeneralInformationList: null,

    UpdateGeneralInformationList: {},
    loadingUpdateGeneralInformationList: false,
    errorUpdateGeneralInformationList: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetOneSU_NT_MRI_GeneralInformation.pending, (state, action) => {
        state.loadingGeneralInformationList = true;
        state.GeneralInformationList = action.payload;
        state.errorGeneralInformationList = null;
      })
      .addCase(
        GetOneSU_NT_MRI_GeneralInformation.fulfilled,
        (state, action) => {
          state.loadingGeneralInformationList = false;
          state.GeneralInformationList = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(GetOneSU_NT_MRI_GeneralInformation.rejected, (state, action) => {
        state.loadingGeneralInformationList = false;
        state.errorGeneralInformationList = action.payload;
      })

      .addCase(UpdateSU_NT_MRI_GeneralInformation.pending, (state, action) => {
        state.loadingUpdateGeneralInformationList = true;
        state.UpdateGeneralInformationList = action.payload;
        state.errorUpdateGeneralInformationList = null;
      })
      .addCase(
        UpdateSU_NT_MRI_GeneralInformation.fulfilled,
        (state, action) => {
          state.loadingUpdateGeneralInformationList = false;
          state.UpdateGeneralInformationList = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(UpdateSU_NT_MRI_GeneralInformation.rejected, (state, action) => {
        state.loadingUpdateGeneralInformationList = false;
        state.errorUpdateGeneralInformationList = action.payload;
      });
  },
});

export default GeneralInformation.reducer;
